<template>
	<div>
		<div class="like w">
			<div class="title" v-html="'<span></span> '+param.title"></div>
			<div class="list">
				<div class="item" v-for="(item,index) in param.list[0].goods_list" :key="index">
					<router-link :to="{path:'/pages/goods/goods',query:{id:item.id}}" target="_blank">
						<img class="item-img" :src="item.pic_url" alt />
						<div class="item-name" v-text="item.name"></div>
						<div class="item-pic" v-text="'¥ '+item.price"></div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				
			};
		}
	};
</script>

<style lang="scss">
	.like {
		.title {
			margin-top: 40px;
			padding-bottom: 20px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 28px;
			font-weight: 600;
			box-sizing: border-box;
			vertical-align: middle;

			span {
				width: 16px;
				height: 16px;
				display: block;
				border-radius: 16px;
				background-color: #ff0e25;
				margin-right: 10px;
			}
		}

		.list {
			display: flex;
			flex-wrap: wrap;

			.item {
				width: 230px;
				height: 328px;
				background-color: #fff;
				padding: 24px 23px;
				box-sizing: border-box;
				margin-right: 10px;
				margin-top: 10px;
				transition: .5s;
				-moz-transition: .5s;
				-webkit-transition: .5s;
				-o-transition: .5s;
				a{
					display: block;
				}
				.item-img {
					width: 184px;
					height: 184px;
				}

				.item-name {
					margin-top: 24px;
					width: 100%;
					padding: 0 26px;
					text-align: center;
					box-sizing: border-box;
					font-size: 14px;
					height: 40px;
					line-height: 20px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					transition: .5s;
					-moz-transition: .5s;
					-webkit-transition: .5s;
					-o-transition: .5s;
				}

				.item-pic {
					margin-top: 16px;
					font-size: 16px;
					color: #ff0e25;
					text-align: center;
				}
				&:hover{opacity: 0.8;}
				&:hover .item-name{color: #ff0e25;}
			}

			:nth-child(5n) {
				margin-right: 0;
			}
		}
	}
</style>
